import { createContext, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const LocaleTransitionContext = createContext(null);

// Custom event for FLIP animations to capture positions before language change
export const LOCALE_WILL_CHANGE_EVENT = 'localeWillChange';

export function LocaleTransitionProvider({ children }) {
  const { i18n } = useTranslation();

  const changeLanguage = useCallback((newLang) => {
    // Dispatch event BEFORE changing language so components can capture positions
    window.dispatchEvent(new CustomEvent(LOCALE_WILL_CHANGE_EVENT));
    i18n.changeLanguage(newLang);
  }, [i18n]);

  const toggleLanguage = useCallback(() => {
    const newLang = i18n.language === 'ko' ? 'en' : 'ko';
    changeLanguage(newLang);
  }, [i18n.language, changeLanguage]);

  return (
    <LocaleTransitionContext.Provider value={{
      changeLanguage,
      toggleLanguage,
      currentLanguage: i18n.language
    }}>
      {children}
    </LocaleTransitionContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useLocaleTransition() {
  const context = useContext(LocaleTransitionContext);
  if (!context) {
    throw new Error('useLocaleTransition must be used within a LocaleTransitionProvider');
  }
  return context;
}
